import React, { useState, useEffect } from 'react';
// import Stepper from "../common/Stepper";
import StepsHeader from '../../../home/components/functional/steps-header/steps.component';
import {
  FETCH_SUCCESS,
  FETCH_ERROR,
  MODULE_ID,
  DEDICATED_FEASIBILITY_RESPONSE,
  serviceOptions,
  CUSTOMER_DETAIL,
  AUTHORIZATION_HEADER,
  AUTHORIZED_SIGNATORY,
  DEDICATED_CUSTOMER_DETAIL,
  SELECTED_PARTY_ACCOUNT,
  SELECTED_PARTY_DATA
} from '../../../home/common/constants/constants';
import { stopBackgroundScrolling, navigateTo, getFromSessionStorage, removeFromSessionStorage } from '../../../common/utils/app.utils';
import MainLoader from 'b2b-ui-components-lib/lib/components/roundLoader';
// import "../common/stepper.scss";
import '../common/common.scss';
import Input from 'b2b-ui-components-lib/lib/components/input';
import Select from 'b2b-ui-components-lib/lib/components/select';
import RadioGroup from 'b2b-ui-components-lib/lib/components/radioGroup';
import graphic from '../images/graphic.svg';
import router from '../images/Router.svg';
import Bandwidth from '../images/Bandwidth-Monitor.svg';
import enoc from '../images/eNOC.svg';
import { ROUTES, MOENGAGE_ANALYTICS_EVENT } from '../../../common/constants/app.constants';
import { trackMOEEvent } from '../../../common/services/moengage.service';
import { useHistory } from 'react-router-dom';
import { fetchPlans, sendQuotation, addDiConnectionDetails } from '../../../common/helper/api.helper';
import ServicesPopup from '../servicesPopup/servicesPopup';
import appConfig from '../../../config/config';
import { faOnSendQuoteClick } from '../../services/analytics.service';
import Button from 'b2b-ui-components-lib/lib/components/button';

const Quotation = ({ plans, servicetype, setservicetype, setactiveStep, pincode }) => {
  useEffect(() => {
    let accessToken = localStorage.getItem('accessToken');
    if (!accessToken && getFromSessionStorage(MODULE_ID, AUTHORIZED_SIGNATORY)) {
      removeFromSessionStorage(MODULE_ID, AUTHORIZED_SIGNATORY);
      removeFromSessionStorage(MODULE_ID, SELECTED_PARTY_ACCOUNT);
      removeFromSessionStorage(MODULE_ID, SELECTED_PARTY_DATA);
      removeFromSessionStorage(MODULE_ID, AUTHORIZATION_HEADER);
      navigateTo(appConfig.dedicatedhomePageUrl);
    }
    if (plans.length) {
      let speedArr = plans.map((item) => ({ displayName: item.speed, key: item.speed }));
      setspeedArray(speedArr);
    }
    trackMOEEvent(MOENGAGE_ANALYTICS_EVENT.UNAUTH_PLAN_PAGE_VISIT);
  }, [plans]);

  const contractPeriodOptions = [
    { key: '1', displayName: '1 Year' },
    { key: '2', displayName: '2 Years' },
    { key: '3', displayName: '3 Years' },
    { key: '4', displayName: '4 Years' },
    { key: '5', displayName: '5 Years' }
  ];

  let history = useHistory();
  let [selectedserviceOption, setselectedserviceOption] = useState(serviceOptions[0]);
  let [selectedContract, setselectedContract] = useState(null);
  let [speedArray, setspeedArray] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  const [selectedvalue, setselectedvalue] = useState(null);
  const onChange = (value) => setselectedvalue(value);
  let [showmorePopup, setshowmorePopup] = useState(false);

  const isdisabled = !(selectedContract && selectedContract.key && selectedvalue && selectedvalue.key);
  let feasibilityResponse = getFromSessionStorage(MODULE_ID, DEDICATED_FEASIBILITY_RESPONSE);
  let pinCode = feasibilityResponse && feasibilityResponse.address && feasibilityResponse.address.pinCode;
  const checkdisabled = () => {};

  const moreClickHandler = () => {
    setshowmorePopup(true);
    stopBackgroundScrolling(true);
  };
  const closemorepopup = () => {
    setshowmorePopup(false);
    stopBackgroundScrolling();
  };
  const sendquote = () => {
    trackMOEEvent(MOENGAGE_ANALYTICS_EVENT.UNAUTH_SUBMIT_PLAN, { bandwidth: selectedvalue.key, service: servicetype, contractPeriod: selectedContract.key });
    faOnSendQuoteClick(servicetype, selectedContract && selectedContract.key, selectedvalue && selectedvalue.key);
    let quotepayload = {
      pincode: pincode,
      bandwidth: selectedvalue.key,
      service: servicetype,
      contractPeriod: selectedContract.key
    };
    let connectionDetails = getFromSessionStorage(MODULE_ID, DEDICATED_CUSTOMER_DETAIL);
    let feasibilityId = feasibilityResponse.feasibilityId;
    let feasibilityStatus = feasibilityResponse.feasibilityStatus;
    let diPayload = [
      {
        planDetail: { planPeriod: selectedContract.key, speed: selectedvalue.key, service: servicetype },
        feasibilityId: feasibilityId,
        feasibilityStatus: feasibilityStatus,
        ...connectionDetails
      }
    ];

    let promises = Promise.all([sendQuotation(quotepayload), addDiConnectionDetails(diPayload)]);
    setisLoading(true);
    promises
      .then((res) => {
        history.push(ROUTES.DEDICATED_THANK_YOU, { leadId: res[0] && res[0].data && res[0].data.result, hideNetworkSteps: true });
        setisLoading(false);
      })
      .catch((err) => {
        setisLoading(false);
      });
  };

  const onServiceChange = (value) => {
    setselectedserviceOption(value);
    setservicetype(value.value);
  };

  const onContractChange = (value) => {
    setselectedContract(value);
  };
  return (
    <React.Fragment>
      {isLoading ? (
        <div className="container round-loader">
          <MainLoader />
          <p className="loader-heading">
            <span className="color-red">Loading…</span>
            <br />
            Please Wait.
          </p>
        </div>
      ) : (
        <div className="main-controller">
          {/* <Stepper /> */}
          {/* <StepsHeader isdedicatedJourney={true} /> */}
          <section className="form-section">
            <div className="accordion-card">
              <div className="accordion-content">
                <div className="row">
                  <div className="flg-lg-8 flg-md-8 flg-sm-12">
                    <div className="form-area">
                      <h5>Provide details to get a customized plan as per your business need. We will share a quotation to your email address.</h5>
                      <div className="field_section">
                        <div className="row">
                          <div className="flgcol">
                            <p>How much bandwith do you require? </p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="flg-lg-5 flg-sm-12">
                            <div className="select-area">
                              <div className="field-control">
                                <Select
                                  placeholder="Choose required bandwidth"
                                  value={selectedvalue}
                                  onChange={onChange}
                                  options={speedArray}
                                  // placeholder="Select Location"
                                  required
                                  touched
                                  // errors={["Field is required"]}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* <div className="success_text">
                        This bandwidth is ideal for 5 users. The media type can
                        be FTTH
                      </div> */}
                      </div>
                      <div className="radio-section">
                        <p>What service type do you require?</p>
                        <div className="radio-area">
                          <RadioGroup options={serviceOptions} value={selectedserviceOption} onChange={onServiceChange} />
                        </div>
                        <div className={`services ${servicetype == 'MANAGED' ? 'active' : ''}`}>
                          <ul className="service_list">
                            <li>
                              <span className="icon">
                                <img src={router} alt="Router" />
                              </span>
                              <strong>Router Hardware</strong>
                            </li>
                            <li>
                              <span className="icon">
                                <img src={Bandwidth} alt="Router" />
                              </span>
                              <strong>Bandwidth Monitor Widget</strong>
                            </li>
                            <li>
                              <span className="icon">
                                <img src={enoc} alt="eNOC" />
                              </span>
                              <strong>e-NOC Managed Service</strong>
                            </li>
                          </ul>
                          <div className="more" onClick={moreClickHandler}>
                            <span>Know more</span>
                          </div>
                        </div>
                      </div>
                      <ServicesPopup showmorePopup={showmorePopup} closemorepopup={closemorepopup} />

                      <div className="row">
                        <div className="flgcol">
                          <p>What is the contract duration of the plan you want? </p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="flg-lg-5 flg-sm-12">
                          <Select
                            placeholder="Choose a contract period"
                            value={selectedContract}
                            onChange={onContractChange}
                            options={contractPeriodOptions}
                            // placeholder="Select Location"
                            required
                            touched
                            // errors={["Field is required"]}
                          />
                        </div>
                      </div>
                      <div className="next-button">
                        <Button disabled={isdisabled} className="activebtn" onClick={sendquote} displayName="Send Quote" />
                      </div>
                    </div>
                  </div>
                  <div className="flg-lg-4 flg-md-4 flg-sm-12">
                    <div className="graphic-pic">
                      <img src={graphic} alt="Graphic" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      )}
    </React.Fragment>
  );
};

export default Quotation;
